export const optionsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  rowGap: "20px",

  justifyContent: "flex-start",
  mx: "-10px",
};

export const optionContainerOuter = ({ isMobile }) => ({
  width: isMobile ? "100%" : "50%",
  px: "10px",
});

export const optionContainerInner = ({ isSelected }) => ({
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  alignItems: "center",
  background: "white",
  minHeight: "294px",
  width: "100%",

  padding: isSelected ? "19px" : "20px",
  color: isSelected ? "primary" : "text",
  borderColor: isSelected ? "primary" : "grey5",
  border: isSelected ? "solid 2px" : "solid 1px",
});

export const heading = {
  textTransform: "uppercase",
  textAlign: "center",
  mb: "10px",
};

export const subHeading = {
  fontSize: "16px",
  fontStyle: "normal",
};

export const subHeading2 = {
  mb: "20px",
};

export const image = (image) => ({
  height: 0,
  width: "100%",
  paddingTop: `${(56 / 250) * 100}%`,
  backgroundImage: `url(${image})`,
  backgroundSize: "cover",
  backgroundColor: "transparent",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "50% 50%",
  mb: "10px",

  position: "relative",
});

export const dot = ({ position, isDotSelected }) => ({
  height: "10px",
  width: "10px",
  border: "solid 1px",
  borderRadius: "1000px",
  background: isDotSelected ? "primary" : "white",
  borderColor: isDotSelected ? "primary" : "black",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  ...position,
  cursor: "pointer",

  "&:after": {
    content: '""',

    width: "2px",
    height: "15px",
    position: "absolute",
    backgroundColor: "primary",
    display: isDotSelected ? "block" : "none",
    top: "100%",
    left: "50%",
    marginLeft: "-1px",
  },
});

export const bladeSegmentDescription = {
  mb: "20px",
  textAlign: "center",
  color: "primary",
};
